import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getQuickReports } from "../../utils/oneintelligence/OneIntelligenceHelper";

function useGetQuickReports(visible) {
    const [activeCollapse, setActiveCollapse] = useState([]);
    const [qrList, setQRList] = useState([]);
    const [tempSelected, settempSelected] = useState(null);

    const { selectedQuickReport } = useSelector((state) => state.reports);
    useEffect(() => {
        if (visible) {
            setQRList(getQuickReports());
            if (selectedQuickReport) {
                setActiveCollapse([selectedQuickReport.parent.id]);
                settempSelected(selectedQuickReport);
            }
        }
    }, [visible, selectedQuickReport]);

    return {
        activeCollapse,
        tempSelected,
        setActiveCollapse,
        settempSelected,
        qrList
    };
}

export default useGetQuickReports;
